import { render, staticRenderFns } from "./StoreAppointmentsLayout.vue?vue&type=template&id=18120fbe&scoped=true"
import script from "./StoreAppointmentsLayout.vue?vue&type=script&lang=js"
export * from "./StoreAppointmentsLayout.vue?vue&type=script&lang=js"
import style0 from "./StoreAppointmentsLayout.vue?vue&type=style&index=0&id=18120fbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18120fbe",
  null
  
)

export default component.exports